<template>
  <div :style="frameStyle" class="gallery-image-frame">
    <img
      v-img="{
        title,
        src,
        sourceButton,
        group,
      }"
      :alt="title"
      :class="imageClass"
      :src="thumbnailSrc"
      :style="imageStyle"
      :width="width ? width : null"
    />
  </div>
</template>

<script type="text/babel">
import Vue from "vue";
import VueImg from "v-img";

Vue.use(VueImg);

export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    src: {
      type: String,
      required: true,
    },
    sourceButton: {
      type: Boolean,
      default: true,
    },
    group: {
      type: String,
      default: undefined,
    },
    thumbnailSrc: {
      type: String,
      required: true,
    },
    framed: {
      type: Boolean,
      default: true,
    },
    imageClass: {
      type: String,
      default: "",
    },
    width: {
      type: Number,
      default: null,
    },
    height: {
      type: Number,
      default: null,
    },
  },

  computed: {
    frameStyle() {
      if (!this.framed) {
        return "";
      }

      const width = this.width ? `width: ${this.width}px;` : "";
      const height = this.width ? `height: ${this.height}px;` : "";

      return `${width} ${height} max-width: 100%`;
    },

    imageStyle() {
      const width = this.width ? `max-width: ${this.width - 16}px;` : "";
      const height = this.width ? `max-height: ${this.height - 16}px;` : "";

      return `${width} ${height} max-width: 100%`;
    },
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.gallery-image-frame {
  background-color: #cbcbcb;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
}
</style>
